import { createGRPCAction, RequestActionType } from '@fullstory/redux-util';
import { SearchServicePublic as svc, ListEventsRequest } from '@fullstory/proto/fs/services/alexa';
import jstz from 'jstz';
import { SearchEventsTypes } from './types';
import { Event, TimeRange } from '@fullstory/proto/fs/api/segment';

export const alexaGrpcTimeoutHeader = { 'GRPC-Timeout': '1M' };
const pageSize = 10;

export const SearchEventsRequestActions = {
  searchEvents: (
    orgId: string,
    event: Event | null,
    pageToken: string,
    timeRange: TimeRange | null,
    batchOptions?: {
      maxOutgoingRequests: number;
      id: string;
    },
    force?: boolean,
  ) => {
    const req = createListEventsRequest(orgId, event, pageToken, timeRange);

    return createGRPCAction<typeof svc.ListEvents>()(
      {
        type: SearchEventsTypes.ListEventsRequest,
        grpcFunction: svc.ListEvents,
        body: req,
        settings: {
          batchOptions,
          headers: alexaGrpcTimeoutHeader,
        },
        readWrite: 'write',
        force,
      },
      SearchEventsTypes.ListEventsSuccess,
      SearchEventsTypes.ListEventsFailure,
    );
  },
};

const createListEventsRequest = (
  orgId: string,
  event: Event | null,
  pageToken: string,
  timeRange: TimeRange | null,
): ListEventsRequest => ({
  pageInfo: {
    pageToken,
    pageSize,
    skip: 0,
  },
  orgId,
  timeRange,
  event,
  timezone: jstz.determine().name(),
  now: null,
});

export type SearchEventsActions = RequestActionType<typeof SearchEventsRequestActions>;
